module.exports = __webpack_public_path__ + "static/media/home-hero-phones-new.9073f4d4.png";